export const props = {
  showGroupEditModal: Function,
  isOwner: {
    type: Boolean,
    default: false
  }
}
